import { useState } from "react";
import { Button, Form, Modal, FormCheckProps } from "react-bootstrap";

interface GuardedCheckProps extends Omit<FormCheckProps, "onChange"> {
  confirmationMessage: string | React.ReactNode;
  showConfirmationOnChange?: boolean;
  checked: boolean;
  onChangeChecked: (checked: boolean) => void;
}

const GuardedCheck = (props: GuardedCheckProps) => {
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  const forwardedProps: Partial<GuardedCheckProps> = { ...props };
  delete forwardedProps.confirmationMessage;
  delete forwardedProps.showConfirmationOnChange;
  delete forwardedProps.onChangeChecked;

  return (
    <>
      <Modal
        show={showConfirmationModal}
        onHide={() => setShowConfirmationModal(false)}
        backdrop="static"
      >
        <Modal.Body>{props.confirmationMessage}</Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowConfirmationModal(false)}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              setShowConfirmationModal(false);
              props.onChangeChecked(!props.checked);
            }}
          >
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
      <Form.Check
        {...forwardedProps}
        onChange={() =>
          props.showConfirmationOnChange
            ? setShowConfirmationModal(true)
            : props.onChangeChecked(!props.checked)
        }
      />
    </>
  );
};

export default GuardedCheck;
